import { usePageMeta } from "../lib/use-page-meta";

function LegalPage({ title, description, path, updated, children }) {
  usePageMeta({ title, description, path });

  return (
    <div className="container py-14">
      <div className="mx-auto max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          The small print
        </p>
        <h1 className="mt-2 font-serif text-4xl font-semibold tracking-tight sm:text-5xl">
          {title}
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">Last updated {updated}</p>
        <div className="prose-copy mt-8">{children}</div>
      </div>
    </div>
  );
}

export default LegalPage;
